/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Clients_Validation_Dob_Invalid_YearInputs */

const en_clients_validation_dob_invalid_year = /** @type {(inputs: Clients_Validation_Dob_Invalid_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Year must be between 1900 and ${i?.year}.`)
};

const pt_br2_clients_validation_dob_invalid_year = /** @type {(inputs: Clients_Validation_Dob_Invalid_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O ano deve ser entre 1900 e ${i?.year}.`)
};

/**
* | output |
* | --- |
* | "Year must be between 1900 and {year}." |
*
* @param {Clients_Validation_Dob_Invalid_YearInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_dob_invalid_year = /** @type {((inputs: Clients_Validation_Dob_Invalid_YearInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Dob_Invalid_YearInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_dob_invalid_year(inputs)
	return pt_br2_clients_validation_dob_invalid_year(inputs)
});